import script from "./SingleSideSteps.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleSideSteps.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__